import "regenerator-runtime/runtime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
import consola from 'consola';
import userQuery from '~/graphql/user/me.gql';
import profileQuery from '~/graphql/user/profile.gql';
import ordersQuery from '~/graphql/user/orders.gql';
import orderQuery from '~/graphql/user/order.gql';
import addressesQuery from '~/graphql/user/address/addresses.gql';
import createUserAddressQuery from '~/graphql/user/address/createUserAddress.gql';
import updateUserAddressMutation from '~/graphql/user/address/updateUserAddress.gql';
import updateUserInformationMutation from '~/graphql/user/updateUserInformation.gql';
import updateUserPasswordMutation from '~/graphql/user/updateUserPassword.gql';
import discountsQuery from '~/graphql/user/discounts.gql';
import updateUserOptinMutation from '~/graphql/user/updateUserOptin.gql';
import deleteUserAddressQuery from '~/graphql/user/address/deleteUserAddress.gql';
import subscribeToNewsletterMutation from '~/graphql/user/newsletter.gql';
import isValidToken from '~/helpers/connection-helper';

function fetchUser(_x) {
  return _fetchUser.apply(this, arguments);
}

function _fetchUser() {
  _fetchUser = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee(context) {
    var _ref, data;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!isValidToken()) {
              _context.next = 6;
              break;
            }

            _context.next = 3;
            return context.app.apolloProvider.defaultClient.query({
              fetchPolicy: 'network-only',
              query: userQuery,
              context: {
                headers: {
                  Authorization: "Bearer ".concat(localStorage.getItem('MDM_ACCESS_TOKEN'))
                }
              }
            });

          case 3:
            _ref = _context.sent;
            data = _ref.data;
            return _context.abrupt("return", data && data.user);

          case 6:
            return _context.abrupt("return", null);

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _fetchUser.apply(this, arguments);
}

function fetchUserProfile(_x2) {
  return _fetchUserProfile.apply(this, arguments);
}

function _fetchUserProfile() {
  _fetchUserProfile = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee2(context) {
    var _ref2, data;

    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!isValidToken()) {
              _context2.next = 6;
              break;
            }

            _context2.next = 3;
            return context.app.apolloProvider.defaultClient.query({
              fetchPolicy: 'network-only',
              query: profileQuery,
              context: {
                headers: {
                  Authorization: "Bearer ".concat(localStorage.getItem('MDM_ACCESS_TOKEN'))
                }
              }
            });

          case 3:
            _ref2 = _context2.sent;
            data = _ref2.data;
            return _context2.abrupt("return", data && data.user);

          case 6:
            return _context2.abrupt("return", null);

          case 7:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _fetchUserProfile.apply(this, arguments);
}

function fetchUserOrders(_x3, _x4, _x5) {
  return _fetchUserOrders.apply(this, arguments);
}

function _fetchUserOrders() {
  _fetchUserOrders = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee3(context, limit, manageOrdersErrors) {
    var _ref3, data, errors;

    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (!isValidToken()) {
              _context3.next = 8;
              break;
            }

            _context3.next = 3;
            return context.app.apolloProvider.defaultClient.query({
              fetchPolicy: 'network-only',
              errorPolicy: manageOrdersErrors ? 'all' : 'none',
              query: ordersQuery,
              context: {
                headers: {
                  Authorization: "Bearer ".concat(localStorage.getItem('MDM_ACCESS_TOKEN'))
                }
              },
              variables: {
                limit: limit,
                mockOrdersEnabled: +localStorage.getItem('MOCK_ORDERS_ENABLED')
              }
            });

          case 3:
            _ref3 = _context3.sent;
            data = _ref3.data;
            errors = _ref3.errors;

            if (manageOrdersErrors && errors) {
              consola.error(errors);
            }

            return _context3.abrupt("return", data && data.orders);

          case 8:
            return _context3.abrupt("return", null);

          case 9:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _fetchUserOrders.apply(this, arguments);
}

function fetchUserOrder(_x6, _x7) {
  return _fetchUserOrder.apply(this, arguments);
}

function _fetchUserOrder() {
  _fetchUserOrder = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee4(context, reference) {
    var locale, response;
    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            if (!isValidToken()) {
              _context4.next = 6;
              break;
            }

            locale = context.state.i18n.currentLocale.iso;
            _context4.next = 4;
            return context.app.apolloProvider.defaultClient.query({
              fetchPolicy: 'network-only',
              query: orderQuery,
              context: {
                headers: {
                  Authorization: "Bearer ".concat(localStorage.getItem('MDM_ACCESS_TOKEN'))
                }
              },
              variables: {
                reference: reference,
                locale: locale,
                mockOrdersEnabled: +localStorage.getItem('MOCK_ORDERS_ENABLED')
              }
            });

          case 4:
            response = _context4.sent;
            return _context4.abrupt("return", response.data);

          case 6:
            return _context4.abrupt("return", null);

          case 7:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _fetchUserOrder.apply(this, arguments);
}

function fetchUserAddresses(_x8) {
  return _fetchUserAddresses.apply(this, arguments);
}

function _fetchUserAddresses() {
  _fetchUserAddresses = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee5(context) {
    var response;
    return regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            if (!isValidToken()) {
              _context5.next = 5;
              break;
            }

            _context5.next = 3;
            return context.app.apolloProvider.defaultClient.query({
              fetchPolicy: 'network-only',
              query: addressesQuery,
              context: {
                headers: {
                  Authorization: "Bearer ".concat(localStorage.getItem('MDM_ACCESS_TOKEN'))
                }
              }
            });

          case 3:
            response = _context5.sent;
            return _context5.abrupt("return", response.data);

          case 5:
            return _context5.abrupt("return", null);

          case 6:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _fetchUserAddresses.apply(this, arguments);
}

function deleteUserAddress(_x9, _x10, _x11, _x12) {
  return _deleteUserAddress.apply(this, arguments);
}

function _deleteUserAddress() {
  _deleteUserAddress = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee6(context, addressId, addressType, addressAlias) {
    var response;
    return regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            if (!isValidToken()) {
              _context6.next = 5;
              break;
            }

            _context6.next = 3;
            return context.app.apolloProvider.defaultClient.mutate({
              mutation: deleteUserAddressQuery,
              context: {
                headers: {
                  Authorization: "Bearer ".concat(localStorage.getItem('MDM_ACCESS_TOKEN'))
                }
              },
              variables: {
                addressId: addressId,
                addressType: addressType,
                addressAlias: addressAlias
              }
            });

          case 3:
            response = _context6.sent;
            return _context6.abrupt("return", response.data);

          case 5:
            return _context6.abrupt("return", null);

          case 6:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _deleteUserAddress.apply(this, arguments);
}

function createUserAddress(_x13, _x14) {
  return _createUserAddress.apply(this, arguments);
}

function _createUserAddress() {
  _createUserAddress = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee7(context, address) {
    var response;
    return regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            if (!isValidToken()) {
              _context7.next = 5;
              break;
            }

            _context7.next = 3;
            return context.app.apolloProvider.defaultClient.mutate({
              mutation: createUserAddressQuery,
              context: {
                headers: {
                  Authorization: "Bearer ".concat(localStorage.getItem('MDM_ACCESS_TOKEN'))
                }
              },
              variables: {
                address: address
              }
            });

          case 3:
            response = _context7.sent;
            return _context7.abrupt("return", response.data);

          case 5:
            return _context7.abrupt("return", null);

          case 6:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));
  return _createUserAddress.apply(this, arguments);
}

function updateUserAddress(_x15, _x16, _x17) {
  return _updateUserAddress.apply(this, arguments);
}

function _updateUserAddress() {
  _updateUserAddress = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee8(context, addressId, address) {
    var response;
    return regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            if (!isValidToken()) {
              _context8.next = 5;
              break;
            }

            _context8.next = 3;
            return context.app.apolloProvider.defaultClient.mutate({
              mutation: updateUserAddressMutation,
              context: {
                headers: {
                  Authorization: "Bearer ".concat(localStorage.getItem('MDM_ACCESS_TOKEN'))
                }
              },
              variables: {
                addressId: addressId,
                address: address
              }
            });

          case 3:
            response = _context8.sent;
            return _context8.abrupt("return", response.data);

          case 5:
            return _context8.abrupt("return", null);

          case 6:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));
  return _updateUserAddress.apply(this, arguments);
}

function updateUserInformation(_x18, _x19) {
  return _updateUserInformation.apply(this, arguments);
}

function _updateUserInformation() {
  _updateUserInformation = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee9(context, user) {
    var response;
    return regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            if (!isValidToken()) {
              _context9.next = 5;
              break;
            }

            _context9.next = 3;
            return context.app.apolloProvider.defaultClient.mutate({
              mutation: updateUserInformationMutation,
              context: {
                headers: {
                  Authorization: "Bearer ".concat(localStorage.getItem('MDM_ACCESS_TOKEN'))
                }
              },
              variables: {
                user: user
              }
            });

          case 3:
            response = _context9.sent;
            return _context9.abrupt("return", response.data);

          case 5:
            return _context9.abrupt("return", null);

          case 6:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));
  return _updateUserInformation.apply(this, arguments);
}

function updateUserPassword(_x20, _x21, _x22) {
  return _updateUserPassword.apply(this, arguments);
}

function _updateUserPassword() {
  _updateUserPassword = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee10(context, oldPassword, newPassword) {
    var response;
    return regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            if (!isValidToken()) {
              _context10.next = 5;
              break;
            }

            _context10.next = 3;
            return context.app.apolloProvider.defaultClient.mutate({
              mutation: updateUserPasswordMutation,
              context: {
                headers: {
                  Authorization: "Bearer ".concat(localStorage.getItem('MDM_ACCESS_TOKEN'))
                }
              },
              variables: {
                oldPassword: oldPassword,
                newPassword: newPassword
              }
            });

          case 3:
            response = _context10.sent;
            return _context10.abrupt("return", response);

          case 5:
            return _context10.abrupt("return", null);

          case 6:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10);
  }));
  return _updateUserPassword.apply(this, arguments);
}

function fetchDiscounts(_x23) {
  return _fetchDiscounts.apply(this, arguments);
}

function _fetchDiscounts() {
  _fetchDiscounts = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee11(context) {
    var locale, response;
    return regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            if (!isValidToken()) {
              _context11.next = 6;
              break;
            }

            locale = context.state.i18n.currentLocale.iso;
            _context11.next = 4;
            return context.app.apolloProvider.defaultClient.query({
              fetchPolicy: 'network-only',
              query: discountsQuery,
              variables: {
                locale: locale
              },
              context: {
                headers: {
                  Authorization: "Bearer ".concat(localStorage.getItem('MDM_ACCESS_TOKEN'))
                }
              }
            });

          case 4:
            response = _context11.sent;
            return _context11.abrupt("return", response.data);

          case 6:
            return _context11.abrupt("return", null);

          case 7:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11);
  }));
  return _fetchDiscounts.apply(this, arguments);
}

function updateUserOptin(_x24, _x25, _x26) {
  return _updateUserOptin.apply(this, arguments);
}

function _updateUserOptin() {
  _updateUserOptin = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee12(context, input, addressId) {
    var response;
    return regeneratorRuntime.wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            if (!isValidToken()) {
              _context12.next = 5;
              break;
            }

            _context12.next = 3;
            return context.app.apolloProvider.defaultClient.mutate({
              mutation: updateUserOptinMutation,
              context: {
                headers: {
                  Authorization: "Bearer ".concat(localStorage.getItem('MDM_ACCESS_TOKEN'))
                }
              },
              variables: {
                input: input,
                addressId: addressId
              }
            });

          case 3:
            response = _context12.sent;
            return _context12.abrupt("return", response.data);

          case 5:
            return _context12.abrupt("return", null);

          case 6:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee12);
  }));
  return _updateUserOptin.apply(this, arguments);
}

function subscribeToNewsletter(_x27, _x28, _x29) {
  return _subscribeToNewsletter.apply(this, arguments);
}

function _subscribeToNewsletter() {
  _subscribeToNewsletter = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee13(context, email, optIn) {
    var locale, response;
    return regeneratorRuntime.wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            locale = context.state.i18n.currentLocale.iso;
            _context13.next = 3;
            return context.app.apolloProvider.defaultClient.mutate({
              mutation: subscribeToNewsletterMutation,
              variables: {
                email: email,
                optIn: optIn,
                locale: locale
              }
            });

          case 3:
            response = _context13.sent;
            return _context13.abrupt("return", response.data);

          case 5:
          case "end":
            return _context13.stop();
        }
      }
    }, _callee13);
  }));
  return _subscribeToNewsletter.apply(this, arguments);
}

export { createUserAddress, deleteUserAddress, fetchUser, fetchUserProfile, fetchUserOrders, fetchUserOrder, fetchUserAddresses, updateUserAddress, updateUserInformation, updateUserPassword, fetchDiscounts, updateUserOptin, subscribeToNewsletter };